import type { KeyboardEvent, SyntheticEvent } from "react";

interface HideOrShowFiltersButtonProps {
  buttonText: string;
  onClick: (e: SyntheticEvent) => void;
}

export const HideOrShowFiltersButton = ({ buttonText, onClick }: HideOrShowFiltersButtonProps) => (
  <button
    className="hide-or-show-filters-button"
    onClick={onClick}
    onKeyDown={(e: KeyboardEvent) => e.key === "Enter" && onClick(e)}
    type="button"
  >
    {buttonText}
  </button>
);
